import type { PermissionData } from '../types'

export function computeSavePlacePermission(permissionData: PermissionData) {
  if (permissionData.rmOnly) return 'hidden'

  return 'enabled'
}
